import { render, staticRenderFns } from "./PaymentV2.vue?vue&type=template&id=905358aa&scoped=true&"
import script from "./PaymentV2.vue?vue&type=script&lang=js&"
export * from "./PaymentV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905358aa",
  null
  
)

export default component.exports